<template>

    <div class="page-center content-load">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-6 col-xl-offset-3">

                    <div class="login-register-page" v-show="modo == 'confirmar'">
                        
                        <center>
                            <img src="static/config/logo.png" style="width: 180px; margin-bottom: 0px;" class="logo">
                        </center>

                        <div class="welcome-text margin-top-30">
                            <h2 style="font-weight: 300; line-height: 130%;">Você autoriza <b style="font-weight: 500;"><u v-if="detalhes">{{detalhes.usuario.nome}}</u></b> a visualizar as suas informações médicas?</h2>
                        </div>

                        <div class="row" style="justify-content: center; padding-left: 20px; padding-right: 20px;">                                                               
                            <div class="col-xs-12"></div>
                            <div class="col-lg-6 col-xs-12">
                                <button style="opacity: 0.5;" class="button border-red full-width outline margin-bottom-5 color-red" type="button" v-on:click="responder('negar');" v-bind:class="{'red': form.status == 'N'}">
                                    <i class="las la-times"></i>
                                    Não autorizo
                                </button>
                            </div> 
                            <div class="col-lg-6 col-xs-12">
                                <button style="font-weight: 400;" class="button border-green full-width outline margin-bottom-5 color-gray" type="button" v-on:click="responder('aceitar');">
                                    <i class="las la-check-circle"></i>
                                    Sim, autorizo
                                </button>
                            </div>     
                            <div class="col-lg-12 col-xs-12">
                                <button style="font-weight: 500; line-height: 120%;" class="button border-green full-width outline margin-bottom-5 color-green" type="button" v-on:click="responder('aceitar-todos');">
                                    <i class="las la-check-circle"></i>
                                    Autorizar para todos os profissionais desta instituição
                                </button>
                            </div>                                 

                            <div class="col-lg-4 col-xl-4 col-xl-offset-0 col-xs-6 margin-top-25" style="opacity: 0.9">
                                <h5 style="text-align: center; color: #666;">Por quanto tempo?</h5>
                                <select class="" v-model="form.tempo" style="text-align: center;">
                                    <option value="sempre">Sempre</option>
                                    <option value="24h">24 horas</option>
                                    <option value="6m">6 meses</option>
                                </select>                                        
                            </div>

                            <div class="col-xs-12">
                                <p class="margin-bottom-0 margin-top-15" style="line-height: 120%; text-align: center;">
                                    <i class="material-icons" style="font-size: inherit;">check</i>
                                    Ao prosseguir, você concorda com os nossos <a v-on:click="$root.openModal('modal-termos-de-uso')"><b>Termos de Uso</b></a> e a <a v-on:click="$root.openModal('modal-politicas-de-privacidade')"><b>Política de Privacidade</b></a>.
                                </p>
                            </div>

                        </div>
                    </div>

                    <div class="login-register-page" v-show="modo == 'confirmado'">
                        
                        <center>
                            <img src="static/config/logo.png" width="180" class="logo margin-bottom-30">
                            <i class="las la-check-circle" style="font-size: 10em; display: block; color: #59ba92"></i>
                        </center>

                        <div class="welcome-text margin-top-20">
                            <h2>Ok! Permissão atualizada. Obrigado pela atenção.</h2>
                        </div>

                        <div class="row">                                                               


                            <div class="col-lg-12 col-xs-8 col-xs-offset-2 col-xl-offset-0 col-lg-offset-0">
                                <a v-on:click="sair" class="button green full-width margin-top-10 margin-bottom-30">
                                    Sair
                                    <!-- <i class="material-icons">send</i> -->
                                </a>                                        
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>  
    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'AutorizarUsoDados',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            loading: {
                "submit":           false,
            },
            detalhes:               null,
            modo:                   "confirmar",
            form: {
                "cod":              "",
                "acao":             "",
                "tempo":            "sempre"
            }            
        }
    },
    methods: {
        sair: function() {
            var self = this;
            window.location.href = self.$root.config.site;                                 

        },
        responder: function(acao) {
            var self            = this;
            console.log("responder", acao);
            
            confirm("Você tem certeza?", function() {

                loading.show();

                var form = {
                    // "_cod":                 self.$root.user.cod, 
                    // "_token":               self.$root.user.token,
                    "acao":                 acao,
                    "tempo":                self.form.tempo,
                    "cod":                  self.$route.query.c
                };
                    
                axios.put("api/uso-de-dados.php", form)
                .then(response => {

                    console.log("responder()", "success", response.data)
                    loading.hide();
                    alert(response.data.message);

                    self.modo = "confirmado";
                    self.$forceUpdate();

                })
                .catch(error => {

                    console.log("responder()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
            });


        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        // "_cod":         self.$root.user.cod, 
                        // "_token":       self.$root.user.token,                        
                        "cod":          self.$route.query.c
                    }
                };

                axios.get("api/uso-de-dados.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    if (!response.data.result.cod) {
                        window.location.href = self.$root.config.site;                                 
                        return false;
                    }

                    self.detalhes = response.data.result;
                    if (response.data.result.status != 0) {
                        self.modo = "confirmado";
                        self.$forceUpdate();
                    }
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            window.location.href = self.$root.config.site;                             
                        }
                    }                    
                });   
            });   
        }           
    },    
    created: function() {
        var self = this;
        if (!self.$route.query.c) {
            self.$router.push({ 
                name:       "Login",
            }).catch(()=>{});                  
            return false;
        }
        self.form.cod              = self.$route.query.c;        
        self.get();      
    },     
    mounted: function() {
        loading.hide();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .page-confirmaragendamento button.outline {
        background: transparent;
        font-weight: 700;
    }
    .page-confirmaragendamento .mmenu-trigger {
        display: none !important;
    }   
    .page-confirmaragendamento #wrapper {
        padding-top: 0px !important;
    }
    .page-confirmaragendamento .border-green {
        border: 2px solid #30ab4a !important;
        color: #30ab4a
    }
    .page-confirmaragendamento .border-red {
        border: 2px solid #dc3139 !important;
        color: #dc3139
    }
</style>



// WEBPACK FOOTER //
// src/components/AutorizarUsoDados.vue